// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { sapphire as _sapphire } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the sapphire chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 23294
 * Chain Name: Oasis Sapphire
 * Default Block Explorer: https://explorer.oasis.io/mainnet/sapphire
 * Default RPC URL: https://sapphire.oasis.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { sapphire } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: sapphire,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const sapphire = createCommon({
	..._sapphire,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
